var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECF4FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9587 23.166H17.875C16.15 23.166 14.75 24.566 14.75 26.291V29.2073C14.75 29.5485 15.0337 29.8323 15.375 29.8323H23.0837V28.791C23.0837 27.2248 24.25 25.9323 25.7587 25.7073C26 24.9985 26.4837 24.4073 27.1087 24.0323C26.55 23.491 25.7913 23.166 24.9587 23.166Z",
    fill: "#2463AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 17C17.75 16.1662 19.0138 14 21.4163 14C23.805 14 25.0913 16.1662 25.0913 17C25.0825 17 25.0663 17.0087 25.0575 17.0087C23.6575 17.3837 22.7488 15.8588 22.7163 15.7925C22.5688 15.5525 22.2562 15.5263 22.0662 15.7013C20.3 17.3413 17.9412 17.025 17.75 17Z",
    fill: "#2463AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6 17.9C23.475 17.9 22.675 17.1162 22.275 16.6162C20.375 18.1075 18.1338 17.8912 17.675 17.8325C17.5738 19.3525 19.0425 21.5 21.4163 21.5C23.8 21.5 25.265 19.3375 25.1575 17.8337C24.9663 17.8837 24.7838 17.9 24.6 17.9Z",
    fill: "#2463AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2913 27.3337H32.25V26.7087C32.25 25.9037 31.5963 25.25 30.7913 25.25H28.7075C27.9038 25.25 27.25 25.9037 27.25 26.7087V27.3337H26.2088C25.7988 27.3337 25.43 27.505 25.165 27.7775L29.75 30.17L34.3363 27.7775C34.0713 27.505 33.7013 27.3337 33.2913 27.3337ZM28.5 27.3337V26.7087C28.5 26.5937 28.5938 26.5 28.7088 26.5H30.7925C30.9063 26.5 31 26.5937 31 26.7087V27.3337H28.5Z",
    fill: "#7EB6F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0388 31.4292C29.8575 31.5242 29.6412 31.5242 29.4612 31.4292L24.75 28.9717V32.5417C24.75 33.3467 25.4037 34.0004 26.2087 34.0004H33.2925C34.0962 34.0004 34.75 33.3467 34.75 32.5417V28.9717L30.0388 31.4292Z",
    fill: "#7EB6F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternship);
export default __webpack_public_path__ + "static/media/Internship.17894ef1cf744016b736840ae91056ab.svg";
export { ForwardRef as ReactComponent };